import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Dashboard, Login as LoginPage, Users, UserRegistration, OwnerRegistration, Locations, LocationRoles, UnitDetail, Alerts, PasswordReset, Consumption } from './containers';
import 'react-dates/initialize';
import './lib/i18n';
import './lib/fontsLibrary';
import './lib/chart/theme';
import PrivateRoute from './containers/router/PrivateRoute';
import { FAQ, Page, Redirect, RedirectType, Support, GettingStarted } from './components';
import { useLogPageEvent } from 'effects';
import { Provider } from 'react-redux';
import configureStore from './store';

const store = configureStore();

const AppRoutes = () => {
  useLogPageEvent(); 
  return (
    <Switch>
      <Route path="/login">
        <LoginPage />
      </Route>
      <Route path="/account/register/:token?">
        <UserRegistration />
      </Route>
      <Route path="/account/activate/:token?">
        <OwnerRegistration />
      </Route>
      <Route path="/passwordreset/:userId/:resetToken">
        <PasswordReset />
      </Route>
      <Route path="/support/alarms/:alarmId/:pageName">
        <Redirect type={RedirectType.ALARM_SUPPORT} />
      </Route>
      <Route path="/privacy-policy">
        <Redirect type={RedirectType.URL} url="https://meetflo.zendesk.com/hc/en-us/articles/230425728-Privacy-Policies"/>
      </Route>
      <Route path="/terms-of-service">
        <Redirect type={RedirectType.URL} url="https://meetflo.zendesk.com/hc/en-us/articles/230089687-Terms-of-Service"/>
      </Route>
      <Route path="/license-agreement">
        <Redirect type={RedirectType.URL} url="https://meetflo.zendesk.com/hc/en-us/articles/230425668-End-User-License-Agreement"/>
      </Route>
      <PrivateRoute exact path="/">
        <Page><Dashboard /></Page>
      </PrivateRoute>
      <PrivateRoute exact path="/locations">
        <Page><Locations /></Page>
      </PrivateRoute>
      <PrivateRoute path="/locations/:parentId">
        <Page><Locations /></Page>
      </PrivateRoute>
      <PrivateRoute path="/users/:userId/roles/:parentId?">
        <Page><LocationRoles /></Page>
      </PrivateRoute>
      <PrivateRoute path="/unit/:unitId">
        <Page><UnitDetail /></Page>
      </PrivateRoute>
      <PrivateRoute path="/alerts/:currentTab?">
        <Page><Alerts /></Page>
      </PrivateRoute>
      <PrivateRoute path="/users">
        <Page><Users /></Page>
      </PrivateRoute>
      <PrivateRoute path="/usage">
        <Page><Consumption /></Page>
      </PrivateRoute>
      <PrivateRoute path="/guide">
        <Page><GettingStarted /></Page>
      </PrivateRoute>
      <PrivateRoute path="/faq">
        <Page><FAQ /></Page>
      </PrivateRoute>
      <PrivateRoute path="/support">
        <Page><Support /></Page>
      </PrivateRoute>
    </Switch>
  );
}

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <AppRoutes />
      </Router>
    </Provider> 
  );
}

export default App;
